<template>
  <div style="background-color: #000; height: 100%">
    <!-- 头部 -->
    <div class="bt">
      <div style="width: 52.8%; float: left; text-align: right; height: 92.8px">
        <div
          style="
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 32px;
            line-height: 72.8px;
            height: 72.8px;
            color: #fff;
            line-height: 92.8px;
          "
        >
          服务详情
        </div>
      </div>
      <div
        style="width: 45%; float: left; text-align: right; cursor: pointer"
        @click="get()"
      >
        <div class="get">返回</div>
        <div class="img"></div>
      </div>
    </div>
    <!--  -->
    <div class="body">
      <div class="yy">{{actName}}</div>
      <div>
        <table cellspacing="0" cellpalling="0" width="94.93%">
          <tr>
            <td style="border-left: none">
              <div class="property">执行方:</div>
              <div :class="orgName.length <= 11 ? 'intro' : 'intro1'">{{ orgName }}</div>
            </td>
            <td>
              <div class="property">参加人数:</div>
              <div class="intro">{{actJoinPersons}}</div>
            </td>
            <td>
              <div class="property">受益人数:</div>
              <div class="intro">{{actBenefitPersons}}</div>
            </td>
            <td>
              <div class="property">活动费用:</div>
              <div class="intro">{{actCost}}元</div>
            </td>
          </tr>
          <tr>
            <td style="border-left: none; border-bottom: none">
              <div class="property">地点:</div>
              <div :class="two1 <= 11 ? 'intro' : 'intro1'">{{ activityAddress }}</div>
            </td>
            <td style="border-bottom: none">
              <div class="property">时间:</div>
              <div class="intro">{{getLocalTime(actBegin)}}~{{getLocalTime(actEnd)}}</div>
            </td>
            <td style="border-bottom: none">
              <div class="property">分数:</div>
              <div class="intro">{{evalutaion}}</div>
            </td>
            <td style="border-bottom: none"><div class="intro"></div></td>
          </tr>
        </table>
      </div>
      <div
        style="
          background-color: #071323;
          width: 95.04%;
          margin: auto;
          overflow: hidden;
          height: 543px;
          z-index: 99;
          box-sizing: border-box;
          border-raduis: 15px;
        "
      >
        <div class="title1">介绍</div>
        <div class="gd">
          <div class="title2">
            {{activityIntroduction}}
            <!-- <p>一、活动内容：</p>
            <p>1、中国清明网一站式生命服平台介绍，介绍绿色生命契约。</p>
            <p>
              2、冬至来临，清明网为腿脚不方便的老人和有事的无法现场祭祀的老人提供远程实景祭祀的预约。
            </p>
            <p>{{ title1 }}</p>
            <p>二、活动时间：</p>
            <p>{{ title2 }}</p>
            <p>三、活动地点：</p>
            <p>{{ title3 }}</p> -->
          </div>
          
          <!-- 图片 -->
          <div style="margin-left: 22px; margin-bottom: 20px">
            <!-- <div style="display: flex; margin: auto; width: 100%">
              <img src="../../assets/images/map.png" alt="" />
              <img src="../../assets/images/map.png" alt="" />
              <img src="../../assets/images/map.png" alt="" />
            </div>
            <div style="display: flex; margin: auto; width: 100%">
              <img src="../../assets/images/map.png" alt="" />
              <img src="../../assets/images/map.png" alt="" />
              <img src="../../assets/images/map.png" alt="" />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ServiceDetailsPath } from "../../config/details";
export default {
  data() {
    return {
      one: "凯旋街道社会组织服务中心",
      two: 0,
      one1: "凯益荟党建活动室",
      two1: 0,
      title1:
        "3、忆青春保健活动，投毽子比赛等趣味活动，让老人能在游戏中回味青春岁月，也能收获小奖品。4、适老化设施展览，老人可近距离了解科技产物带来的居家设施变化。",
      title2: "12月2日 上午9:00—10:30",
      title3: "凯益荟党建活动室",

      actName:'',
      govName:'',
      actJoinPersons:'',
      actBenefitPersons:'',
      actCost:'',
      activityAddress:'',
actBegin:'',
actEnd:'',
evalutaion:''
    };
  },
  created() {
    this.two = this.one.length;
    this.two1 = this.one1.length;
    this.getDetails();
  },
  methods: {
    get() {
      this.$router.go(-1);
    },
    /* 获取所有数据的方法 */
      async getDetails() {
      // const res =ServiceDetailsPath({id: this.$route.query.id});
      
      const res = await this.postRequest(
        ServiceDetailsPath,
        {id: this.$route.query.id}
      );
      console.log("res==>", res.data);
      if (res.rtnCode == "0000") {
        this.actName = res.data.actName;   // 活动名称
        this.orgName = res.data.orgName;   // 组织名称
        this.actJoinPersons = res.data.actJoinPersons; // 参与人数
        this.actBenefitPersons = res.data.actBenefitPersons;  // 受益人数
        this.actCost = res.data.actCost;   // 活动费用
        this.activityAddress = res.data.activityAddress;   // 活动地址
        this.actBegin = res.data.actBegin;  // 活动开始时间
        this.actEnd = res.data.actEnd; // 活动结束时间
        this.evalutaion = res.data.evalutaion; // 综合评分
        this.activityIntroduction = res.data.activityIntroduction  // 总结
      }
    },
    getLocalTime(timestamp) {  
       var date = new Date(Number(timestamp));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
      // var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
      // var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
      // var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
      
      var strDate = Y+M+D;
      return strDate;//2020-07-30
    }
  },
  
};

</script>

<style scoped>
.bt {
  width: 100%;
  height: 92.8px;
  background: url("../../assets/images/pageHome/topTitle.png") no-repeat
    center/100%;
  /* border:1px solid rgb(0, 110, 255); */
}
.body {
  /* border:1px solid red; */
  margin: auto;
  width: 98.7%;
  height: 968px;
  border-radius: 15px;
  /* background: url("../../assets/images/bg.png") no-repeat center/100%;
  
   */
  background: #07111e;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: 0px;
  margin-bottom: 15px;
  padding-bottom: 4.57%;
  margin-top: 0px;
  /* position: relative;
  top: -20px; */
}
.yy {
  margin: auto;
  margin-top: 22px;
  width: 94.93%;
  background: url("../../assets/socialOrg/tableImg.png") no-repeat center/100%
    100%;
  height: 152px;
  line-height: 152px;
  text-align: center;
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
}
table {
  height: 195px;
  text-align: center;
  border-radius: 0px 3px 3px 0px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  margin: auto;
}
table {
  background: #071a34;
}
table td {
  border-left: 1px #ffffff solid;
  border-bottom: 1px #ffffff solid;
  width: 25%;
  color: rgb(255, 255, 255);
  height: 55px;
  line-height: 55px;
}
.property {
  float: left;
  box-sizing: border-box;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  height: 97.5px;
  line-height: 97.5px;
  margin-left: 30px;
}
.intro {
  float: left;
  text-overflow: ellipsis;
  box-sizing: border-box;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  height: 97.5px;
  line-height: 97.5px;
  margin-left: 30px;
  margin-right: 25px;
  opacity: 0.6;
}
.intro1 {
  float: left;
  word-break: break-all; /*换行*/
  font-size: 24px;
  margin-left: 30px;
  margin-right: 25px;
  width: 61%;
  text-align: left;
  line-height: 40px;
  height: 40px;
  padding-top: 7px;
  opacity: 0.6;
}
.img {
  width: 20px;
  height: 20px;
  float: right;
  background: url("../../assets/socialOrg/goback.png") no-repeat center/100%
    100%;
  margin: 28px;
  margin-right: 9px;
  transform: translateY(8px);
}
.get {
  float: right;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #1080d0;
  margin-top: 21px;
  transform: translateY(8px);
}
.gd {
  overflow: auto;
  height: 463px;
  border-radius: 25px;
  margin: auto;
}
.gd::-webkit-scrollbar {
  display: none;
}
.title1 {
  width: 104px;
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  background: url("../../assets/socialOrg/introTit.png") no-repeat center/100%
    100%;
  text-align: left;
  padding-left: 19px;
  margin: 20px;
  margin-left: 9px;
}
.title2 {
  /* margin: 1.9%; */
  margin-left: 1.11%;
  /* margin: auto; */
  /* margin-top:0px ;
  margin-bottom:0px ; */
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  /* border: hotpink 1px solid; */
  width: 97.33%;
}
img {
  margin-right: 40px;
  margin-top: 17px;
  flex: 1;
  /* width: 100%; */
  height: 193px;
  border: 1px white solid;
}
</style>
